import { analog_bjt } from './analog_bjt';

export class nsvbcp5310mtwg extends analog_bjt {}
